<template>
  <div  class="volumn">
    <div v-for="i in 35" class="volumn--item" :key="i" :class="getColorClassName(i)"></div>
  </div>
</template>
<script>
export default {
  props: {
    volume: {
      type: Number,
      default: 0
    }
  },
  data(){
    return{}
  },
  methods:{
    getColorClassName(i){
      if (i > this.vol) return ''
      if (i < 25) {
        return 'green'
      } else if (i>=32) {
        return 'red'
      } else {
        return 'orange'
      }
    }
  },
  computed: {
    vol() {
      return Math.ceil(this.volume / 100 * 35)
    }
  }
}
</script>
<style lang="scss" scoped>
.volumn {
  display: flex;
  justify-content: space-around;
  height: 100%;
  &--item{
    //padding: 2px 2px;
    width: 8px;
    height: 100%;
    background-color: rgba(215, 215, 215, 1);
    border-radius: 6px;
  }
  .green{
    background-color: rgba(112, 182, 3, 1);
  }
  .orange{
    background-color: rgba(245, 154, 35, 1);
  }
  .red{
    background-color: rgba(217, 0, 27, 1);
  }
}

</style>